import { SpecialTiles, Tiles } from '../Constants';
import { TilesInterface } from '../components/Grid/tiles';
import { ThemeEnum } from '../handlers/ThemeHandler';

export const exportConfig = () => {
  const tiles = JSON.parse(localStorage.getItem(Tiles) as string);
  const specialTiles = JSON.parse(localStorage.getItem(SpecialTiles) as string);
  const theme = JSON.parse(localStorage.getItem('theme') as string);
  const customerLogo = localStorage.getItem('customer-logo') as string;

  if (tiles || specialTiles) {
    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
      JSON.stringify({
        tiles,
        specialTiles,
        theme: ThemeEnum[theme],
        customerLogo
      })
    )}`;

    const link = document.createElement('a');
    link.href = jsonString;
    link.download = 'cockpit-configurator.json';

    link.click();
  } else {
    alert('Bitte konfigurieren Sie einige Kacheln!');
  }
};

export const importConfig = (
  json:
    | {
        theme: string;
        tiles: TilesInterface[];
        specialTiles: TilesInterface[];
        customerLogo: string;
      }
    | undefined,
  setTheme: React.Dispatch<React.SetStateAction<ThemeEnum | undefined>>,
  setLogo: React.Dispatch<
    React.SetStateAction<string | ArrayBuffer | null | undefined>
  >,
  setMainTiles: React.Dispatch<
    React.SetStateAction<TilesInterface[] | undefined>
  >,
  isInSpecialMode: boolean
) => {
  if (json) {
    try {
      if (json.theme) {
        setTheme(ThemeEnum[json.theme]);
      }

      if (json.tiles) {
        localStorage.setItem(Tiles, JSON.stringify(json.tiles));
        !isInSpecialMode && setMainTiles(json.tiles);
      }
      if (json.specialTiles) {
        localStorage.setItem(SpecialTiles, JSON.stringify(json.specialTiles));
        isInSpecialMode && setMainTiles(json.specialTiles);
      }
      setLogo(json.customerLogo);
    } catch (e) {
      alert('error parsing file!');
    }
  }
};
